import Footer from "../../../../components/footer/Footer";
import Header from "../../../../components/header/Header";
import Page from "../../../../page/Page";
import MainTrainings from "./MainTrainings";
import { useTranslation } from "react-i18next";
import _ from "lodash";

const DemoTrainings = () => {

    const { t } = useTranslation();

    return (
        <>
        <Page
            title={"OVA - Consulting | " + t('trainings')}
        >
            <Header/>
            <section className="training-page main homepage">
                <section className="banner" style={{backgroundImage: "url(/assets/expertises/training-1.png)"}}>
                    <div className="banner-content">
                        <div className="container">
                            <p className="title">{t('training_title')}</p>
                            <p className="text">{t('training_text')}</p>
                        </div>
                    </div>
                </section>
                <MainTrainings />
            </section>
            <Footer />
        </Page>
        </>
    )

};

export default DemoTrainings;